<template>
  <el-dialog
      title="Xác nhận chuyển trạng thái"
      :visible.sync="localVisible"
      width="35vw"
      append-to-body
      :close-on-click-modal="false"
      @close="handleClose"
  >
    <hr style="margin-top: -20px"/>
    <div class="gift-status-dialog">
      <p class="gift-status-dialog__message">
        Bạn có chắc chắn muốn chuyển trạng thái quà sang
        <b>{{ targetStatusLabel }}</b>
        không?
      </p>
      <div v-if="requireReason" class="gift-status-dialog__reason">
        <label>Nhập lý do chuyển thông tin</label>
        <el-input
            type="textarea"
            :rows="4"
            resize="none"
            :value="note"
            placeholder="Vui lòng nhập lý do chuyển trạng thái quà tặng"
            @input="$emit('update:note', $event)"
        />
      </div>
    </div>
    <template #footer>
      <el-button @click="localVisible = false">Hủy</el-button>
      <el-button
          type="primary"
          :loading="loading"
          :disabled="loading"
          @click="$emit('submit')"
      >
        Xác nhận
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'MangeGiftProgramStatusDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    targetStatusLabel: {
      type: String,
      default: ""
    },
    requireReason: {
      type: Boolean,
      default: false
    },
    note: {
      type: String,
      default: ""
    }
  },
  computed: {
    localVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>
.gift-status-dialog__message {
  color: #4b5563;
  margin-bottom: 20px;
}

.gift-status-dialog__reason label {
  color: #4b5563;
  display: block;
  font-size: 12px;
  margin-bottom: 6px;
}
</style>
